export default {"src":"/evde-internet/_next/static/media/pen.c04a0af4.svg","height":24,"width":24};